import React, { useEffect } from 'react';
import { CheckCircle2, XCircle, Info, AlertTriangle, X } from 'lucide-react';

const NotificationToast = ({ notification, onClose }) => {
    if (!notification) return null;

    const bgColors = {
        success: 'bg-gradient-to-r from-emerald-500 to-green-600',
        error: 'bg-gradient-to-r from-red-500 to-rose-600',
        info: 'bg-gradient-to-r from-blue-500 to-indigo-600',
        warning: 'bg-gradient-to-r from-amber-500 to-orange-600'
    };

    const icons = {
        success: <CheckCircle2 className="w-5 h-5" />,
        error: <XCircle className="w-5 h-5" />,
        info: <Info className="w-5 h-5" />,
        warning: <AlertTriangle className="w-5 h-5" />
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 4000);
        return () => clearTimeout(timer);
    }, [notification, onClose]);

    return (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 animate-bounce-in">
            <div className={`${bgColors[notification.type]} text-white px-6 py-3 rounded-2xl shadow-2xl flex items-center gap-3`}>
                {icons[notification.type]}
                <span className="font-medium">{notification.message}</span>
                <button onClick={onClose} className="ml-2 opacity-70 hover:opacity-100">
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default NotificationToast;
